export default { sha: '5ccbb339c7423c6feef8b10330de4365969d070a', buildNumber: 'undefined' }
